<template class="ozel-bg">

    <el-form label-position="top" status-icon :model="hekimForm" :rules="rulesHekim" ref="hekimForm"
             class="demo-ruleForm">
        <el-row class="ozel-bg">
            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p" style="position: relative">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft margin-top-20 padding-10">
                    <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                        <el-form-item label='Hekim Adı : ' prop="adSoyad">
                            <el-input
                                    v-model="hekimForm.adSoyad"
                                    v-on:input="inputStyleAlt(hekimForm.adSoyad,'adSoyad')"
                                    placeholder='İsim Soyisim Giriniz'></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                        <el-form-item label='Telefon :' prop="doktorTelefon">
                            <el-input
                                    v-model="hekimForm.doktorTelefon" v-mask="'+90(###)### ## ##'"
                                    placeholder='Telefon Giriniz'></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                        <el-form-item label='E-Posta :' prop="doktorEposta">
                            <el-input
                                    v-model="hekimForm.doktorEposta"
                                    placeholder='E-Posta Giriniz'></el-input>
                        </el-form-item>
                    </el-col>
                </div>
                <div v-for="(item,index) in klinikList">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft margin-top-20 padding-10">
                        <el-col :lg="11" :md="11" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='İl: '>
                                <el-select
                                        v-model="klinikList[index]['ilId']"
                                        filterable
                                        placeholder='İl Seçiniz'
                                        style="width: 100%">
                                    <el-option v-for="item in ilList"
                                               :key="item.baslik"
                                               :label="item.baslik"
                                               :value="item.ilId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Klinik :' prop="baslik">
                                <el-input
                                        v-model="klinikList[index]['baslik']"
                                        placeholder='Klinik Giriniz'>

                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="1" :md="1" :sm="24" :xs="24" class="col-p">
                            <el-button v-if="klinikList.length>1" class="deleteButton" type="danger" size="mini"
                                       icon="el-icon-close" v-on:click="removeKlinik(index)"
                                       circle></el-button>
                        </el-col>
                    </div>
                </div>
                <el-button class="addButton" size="mini" type="primary" v-on:click="klinikEkle"
                           icon="el-icon-plus"></el-button>

                <el-button class="margin-top-20 margin-bottom-20 estas-buton"
                           style="float: right;box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)"
                           type="primary" size="mini" v-on:click="hekimTanimla('hekimForm')">
                    Hekim Tanımla
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
    import ilService from '../../../WSProvider/IlService'
    import hekimService from '../../../WSProvider/HekimService'
    import notification from '../../../notification'
    import EventBus from '@/components/event-bus'
    import yoneticiService from '../../../WSProvider/YoneticiService'
    var base64 = require('base64_js');
    export default {
        name: "HekimTanimlama",
        data() {
            return {
                klinikList: [{
                    ilId: '',
                    baslik: '',
                }],
                ilList: [],
                hekimForm: {

                    adSoyad: '',
                    doktorTelefon: '',
                    doktorEposta: '',
                    klinik: '',
                    il: '',


                },
                rulesHekim: {
                    adSoyad: [{
                        required: true,
                        message: "Lütfen İsim Soyisim Giriniz.",
                        trigger: 'change'
                    }],

                    doktorTelefon: [{
                        required: true,
                        message: "Lütfen Telefon Giriniz.",
                        trigger: 'change'
                    }],
                    doktorEposta: [{
                        type: 'email',
                        required: true,
                        message: "Lütfen E-Posta Giriniz.",
                        trigger: 'change'
                    }]
                },
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userData3H")) {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["tur"]) {
                    if (userData3H["tur"] === '1') {
                        this.getIl();
                    } else if (userData3H["tur"] === '2') {
                        this.getIl();
                    } else if (userData3H["tur"] === '3') {
                        this.getIlYonetici();
                    } else if (userData3H["tur"] === '4') {
                        this.getIlYonetici();
                    } else if (userData3H["tur"] === '5') {
                        this.getIlYonetici();
                    }
                }

            }
        },
        methods: {
            klinikEkle() {
                this.$refs.hekimForm.validate((valid) => {
                    if (valid) {
                        this.klinikList.push({
                            ilId: '',
                            baslik: '',
                        })
                    }
                })
            },
            removeKlinik(item) {
                this.klinikList.splice(item, 1);
            },
            getIl() {
                ilService.il().then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getIlYonetici() {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                yoneticiService.yonetimIlList(userData3H["yonetimKodu"]).then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    }
                })

            },
            inputStyleAlt(val, model) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hekimForm[model] = splitStr.join(' ');
            },
            hekimTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        hekimService.hekimKaydi(this.hekimForm.doktorEposta, this.hekimForm.adSoyad, this.klinikList, this.hekimForm.doktorTelefon).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Hekim başarıyla kaydedildi.');
                                EventBus.$emit("hekimList", true)
                                this.$refs[formName].resetFields();
                                this.klinikList = [{
                                    ilId: '',
                                    baslik: '',
                                }]
                            } else notification.Status(response.status, this);
                        })
                    }
                })

            }
        }
    }
</script>

<style scoped>
    .deleteButton {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 0 0 0 5px;
    }

    .addButton {
        position: absolute;
        left: auto;
        right: 15px;
        top: auto;
        bottom: 72px;
        padding: 5px;
        border-radius: 5px 0 0 0;
    }

    .ozel-bg {
        background-image: url("../../../assets/images/1621.jpg");
        background-position: top;
        background-repeat: no-repeat;
        background-size: cover;
        min-height: 100vh;
    }

    @media only screen and (max-width: 480px) {
        .ozel-bg {
            background-image: none;
        }
    }

</style>